<div class="grid-container">
	<div class="grid-row grid-gap-1">
		<div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"></div>
		<div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
			<div class="usa-card padding-top-2">
				<div class="usa-card__container">
					<header class="usa-card__header">
						<h2 class="usa-card__heading">Forgot Password</h2>
					</header>
					<div *ngIf="requestSubmitted" class="usa-alert usa-alert--success usa-alert--slim">
						<div class="usa-alert__body">
						  <p class="usa-alert__text">
							If your account exists you will receive an email with further instructions. Contact support if you do not receive an email.
						  </p>
						</div>
					</div>
					<div *ngIf="errorSubmittingRequest" class="usa-alert usa-alert--error usa-alert--slim">
						<div class="usa-alert__body">
							<p class="usa-alert__text">
								An error has occurred. Please try again, and if the problem persists, contact support.
							</p>
						</div>
					</div>
					
					<div class="usa-card__body">
						<form [formGroup]="forgotPasswordForm" (ngSubmit)="submitRequest()">
								<div>
									<label class="usa-label" for="email">Email<abbr title="required"
										class="usa-hint usa-hint--required">*</abbr></label>
									<input type="text" id="email" class="usa-input maxw-full" formControlName="email" [maxlength]="254"
									[ngClass]="{
										'border-success': this.forgotPasswordForm.get('email').valid && (this.forgotPasswordForm.get('email').touched || this.forgotPasswordForm.get('email').dirty),
										'border-danger': this.forgotPasswordForm.get('email').invalid && (this.forgotPasswordForm.get('email').touched || this.forgotPasswordForm.get('email').dirty)
									}">
									<div *ngIf="this.forgotPasswordForm.get('email').invalid && (this.forgotPasswordForm.get('email').touched || this.forgotPasswordForm.get('email').dirty)">
										<small class="text-danger" *ngIf="this.forgotPasswordForm.get('email').hasError('required')">
											<svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
												<use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
											  </svg> Email is required
										</small>
										<small class="text-danger" *ngIf="this.forgotPasswordForm.get('email').hasError('email')">
											<svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
												<use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
											  </svg> Email is invalid
										</small>
									</div>
								</div>
								<div>
									<label class="usa-label" for="lastName">Last Name<abbr title="required"
										class="usa-hint usa-hint--required">*</abbr></label>
									<input type="text" class="usa-input maxw-full" id="lastName" formControlName="lastName" [maxlength]="35"
									[ngClass]="{
										'border-success': this.forgotPasswordForm.get('lastName').valid && (this.forgotPasswordForm.get('lastName').touched || this.forgotPasswordForm.get('lastName').dirty),
										'border-danger': this.forgotPasswordForm.get('lastName').invalid && (this.forgotPasswordForm.get('lastName').touched || this.forgotPasswordForm.get('lastName').dirty)
									}">
									<div *ngIf="this.forgotPasswordForm.get('lastName').invalid && (this.forgotPasswordForm.get('lastName').touched || this.forgotPasswordForm.get('lastName').dirty)">
										<small class="text-danger" *ngIf="this.forgotPasswordForm.get('lastName').hasError('required')">
											<svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
												<use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
											</svg> Last Name is required
										</small>
									</div>
								</div>
								<div class="padding-top-105">
									<button type="button" class="usa-button" type="submit" [disabled]="!forgotPasswordForm.valid">Request reset link</button>
								</div>
						</form>
					</div>
					<div class="usa-card__footer text-center">
						<a routerLink="/signon">Back to Sign in</a>
					</div>
				</div>
			</div>
		</div>	
		<div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"></div>
	</div>	
</div>
